import cn from 'clsx'
import s from './ScanningPage.module.scss'
import { FC, useState } from 'react'
import {
  FullHeightSection,
  Text,
  CustomImage,
  Container,
  Button,
} from '@components/ui'
import { CustomImageProps } from '@components/ui/CustomImage/CustomImage'
import {
  FindFitterBlock,
  Fitter,
  ScanningPage as ScanningPageType,
} from '@generated/model/models'
import ScanningPageHero from './ScanningPageHero'
import ScanningPageDetails from './ScanningPageDetails'
import { FittersBlock } from '@components/loretwopage'
import { useJsApiLoader } from '@react-google-maps/api'

type ScanningPageProps = {
  data: ScanningPageType
  fittersSection: FindFitterBlock
  fitters: Fitter[]
  children?: any
}

const ScanningPage: FC<ScanningPageProps> = ({
  data,
  fittersSection,
  fitters,
  children,
}) => {
  const [currentFitter, setCurrentFitter] = useState<Fitter | null>(null)

  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY as string,
    libraries: ['places'],
  })

  return (
    <div className={s.root}>
      <ScanningPageHero data={data} />

      <ScanningPageDetails data={data} />

      <FittersBlock
        fitters={fitters}
        data={fittersSection}
        showSelectButton={false}
        currentFitter={currentFitter}
        setCurrentFitter={setCurrentFitter}
        isLoaded={isLoaded}
      />
    </div>
  )
}

export default ScanningPage
